import React from 'react';
import { Container, Nav, Navbar, Button } from 'react-bootstrap';
import { Link, NavLink, Outlet } from 'react-router-dom';
import {
  FaTachometerAlt,
  FaBox,
  FaShoppingCart,
  FaUsers,
  FaCog,
  FaBars,
  FaSignOutAlt,
  FaUser
} from 'react-icons/fa';
import './AdminLayout.css'; // We'll create this file next

const AdminLayout = () => {

  return (
    <div className="admin-layout">
      {/* Top Navbar */}
      <Navbar bg="dark" variant="dark" className="admin-navbar" expand={false}>
        <Container fluid>
          <Button
            variant="outline-light"
            className="d-md-none me-2"
          >
            <FaBars />
          </Button>

          <Navbar.Brand as={Link} to="/admin" className="me-auto">
            Store Admin
          </Navbar.Brand>

          <div className="d-flex align-items-center">
            <div className="text-light me-3 d-none d-md-block">
              <span>Welcome, Admin</span>
            </div>
            <NavLink to="/" className="text-light me-3">
              <Button variant="outline-light" size="sm">
                View Store
              </Button>
            </NavLink>
            <div className="admin-avatar">
              <FaUser />
            </div>
          </div>
        </Container>
      </Navbar>

      <div className="admin-container">
        {/* Sidebar - Visible on larger screens */}
        <div className="admin-sidebar d-none d-md-block">
          <div className="sidebar-sticky">
            <Nav className="flex-column">
              <Nav.Item>
                <NavLink to="/admin" end className="nav-link">
                  <FaTachometerAlt className="sidebar-icon" /> Dashboard
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink to="/admin/products" className="nav-link">
                  <FaBox className="sidebar-icon" /> Products
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink to="/admin/orders" className="nav-link">
                  <FaShoppingCart className="sidebar-icon" /> Orders
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink to="/admin/customers" className="nav-link">
                  <FaUsers className="sidebar-icon" /> Customers
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink to="/admin/bulk-requests" className="nav-link">
                  <FaBox className="sidebar-icon" /> Bulk Requests
                </NavLink>
              </Nav.Item>
              <Nav.Item>
                <NavLink to="/logout" className="nav-link text-danger mt-5">
                  <FaSignOutAlt className="sidebar-icon" /> Logout
                </NavLink>
              </Nav.Item>
            </Nav>
          </div>
        </div>

        {/* Main Content */}
        <main className="admin-content">
          <Container fluid className="py-4">
            <Outlet />
          </Container>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout; 